import ScrollReveal from 'scrollreveal';

jQuery(function($) {
    $(document).ready(() => {
        // Timeline
        $(function(){
           if ($(window).width() < 768) {
                if ($('.timeline_content').hasClass('fade_left')) {
                    $('.timeline_content').removeClass('fade_left').addClass('fade_right');
                }
                ScrollReveal().reveal('.fade_left', {
                    origin: 'left',
                    distance: '300px',
                    easing: 'ease-in-out',
                    duration: 800,
                });
                ScrollReveal().reveal('.fade_right', {
                    origin: 'right',
                    distance: '300px',
                    easing: 'ease-in-out',
                    duration: 800,
                  });
                } else {
                ScrollReveal().reveal('.fade_left', {
                    origin: 'left',
                    distance: '300px',
                    easing: 'ease-in-out',
                    duration: 800,
                });
                ScrollReveal().reveal('.fade_right', {
                    origin: 'right',
                    distance: '300px',
                    easing: 'ease-in-out',
                    duration: 800,
                });
            }
        });        
    });
});